
import TripplyHeader from '@/components/TripplyHeader.vue'
import AppNav from '@/components/ui/nav/AppNav.vue'
import AppFooter from '@/components/ui/AppFooter.vue'
import AppToasts from '@/components/ui/AppToasts.vue'
import CookieConsent from '@/components/modals/CookieConsent.vue'
import RouteLimitExceeded from '@/components/modals/RouteLimitExceeded.vue'
import AppModals from '@/components/ui/AppModals.vue'

import { initializeStore, store } from '@/store'
import { defineComponent, ref, computed } from  'vue'

export default defineComponent({
  name: 'TripplyApp',
  components: { TripplyHeader, AppNav, AppFooter, AppToasts, AppModals, CookieConsent, RouteLimitExceeded },
  setup() {
    console.log('LOADED')
    
    initializeStore()
    const feedbackModal = ref(false)
    const theme = computed(() => store.global.state.theme)
    const routeStore = computed(() => store.route)
    const userStore = store.user.state
    const user = computed(() => store.auth.state.user)

    const routeLimitExceeded = computed(() => store.user.routeLimitExceeded())

    const cookieModal = computed(() => !store.global.state.cookieConsent)

    return { store, user, routeStore, theme, userStore, cookieModal, feedbackModal, routeLimitExceeded }
  }
})
